import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import UserProvider from '@showliner/shared/context/UserContext';
import { ManagedEntityProvider } from '@showliner/shared/context/ManagedEntityContext';
import { setupAxiosClient } from '@showliner/shared/services/apiClient';
import { rememberUtm, sessionStorageOrNull } from '@showliner/shared/utils/waitlistSignup';
import { Toaster } from 'sonner';
import App from './App';
import './index.css';

// Configure axios for cookie-based auth + CSRF (see apiClient).
setupAxiosClient();

// Keep the campaign tags (utm_*) of the link this visit began on. Links to
// admin's /register carry them across (crossAppLinks.getAdminUrl), since
// sessionStorage stays on this origin.
rememberUtm(sessionStorageOrNull(), window.location.search);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <ManagedEntityProvider>
          <App />
          <Toaster position="bottom-center" richColors />
        </ManagedEntityProvider>
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
);
